module.exports = __webpack_public_path__ + "img/commandcenter_stopped.b76733c2.svg";